/* ============================================================
   PelviPulse PDP — minimal client behavior
   ============================================================ */
(function () {
  'use strict';

  const root = document.querySelector('[data-pelvipulse-root]');
  if (!root) return;

  const $ = (sel, scope) => (scope || root).querySelector(sel);
  const $$ = (sel, scope) => Array.from((scope || root).querySelectorAll(sel));
  const formatMoney = (cents) => {
    if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  };

  /* ---------- product JSON ---------- */
  let productJson = null;
  const jsonEl = root.querySelector('[data-pp-product-json]');
  if (jsonEl) {
    try { productJson = JSON.parse(jsonEl.textContent); } catch (e) { productJson = null; }
  }

  /* ---------- gallery ---------- */
  const track = root.querySelector('[data-pp-track]');
  const slides = $$('[data-pp-slide]');
  const thumbs = $$('[data-pp-thumb]');

  function setActiveGallery(idx) {
    if (!slides.length) return;
    const clamped = Math.max(0, Math.min(idx, slides.length - 1));
    if (track && slides[clamped]) {
      track.scrollTo({ left: slides[clamped].offsetLeft, behavior: 'smooth' });
    }
    thumbs.forEach((t, i) => {
      const active = i === clamped;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }
  function currentGalleryIdx() {
    if (!track || !slides.length) return 0;
    const slideW = slides[0].getBoundingClientRect().width || 1;
    return Math.round(track.scrollLeft / slideW);
  }

  if (track) {
    track.addEventListener('scroll', () => {
      const idx = currentGalleryIdx();
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === idx);
        t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }, { passive: true });
  }
  thumbs.forEach((t) => {
    t.addEventListener('click', () => {
      const idx = parseInt(t.dataset.index, 10) || 0;
      setActiveGallery(idx);
    });
  });
  const prevBtn = root.querySelector('[data-pp-prev]');
  const nextBtn = root.querySelector('[data-pp-next]');
  if (prevBtn) prevBtn.addEventListener('click', () => setActiveGallery(currentGalleryIdx() - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => setActiveGallery(currentGalleryIdx() + 1));

  /* ---------- variant logic ---------- */
  const optionInputs = $$('[data-pp-option-input]');
  const variantIdInput = root.querySelector('[data-pp-variant-id]');
  const priceEl = root.querySelector('[data-pp-price]');
  const comparePriceEl = root.querySelector('[data-pp-compare-price]');
  const savePillEl = root.querySelector('[data-pp-save-pill]');
  const atcBtn = root.querySelector('[data-pp-atc]');
  const atcPriceEl = root.querySelector('[data-pp-atc-price]');
  const atcTextEl = root.querySelector('[data-pp-atc-text]');
  const stockRow = root.querySelector('[data-pp-stock]');
  const stockText = root.querySelector('[data-pp-stock-text]');

  function findMatchingVariant() {
    if (!productJson || !productJson.variants) return null;
    const selected = optionInputs
      .filter((i) => i.checked)
      .sort((a, b) => parseInt(a.dataset.optionPosition, 10) - parseInt(b.dataset.optionPosition, 10))
      .map((i) => i.value);
    if (!selected.length) return productJson.variants[0];
    return productJson.variants.find((v) => {
      const opts = [v.option1, v.option2, v.option3].filter(Boolean);
      return opts.length === selected.length && opts.every((o, idx) => o === selected[idx]);
    }) || null;
  }

  function updateVariantUI() {
    const variant = findMatchingVariant();
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (atcPriceEl) atcPriceEl.textContent = formatMoney(variant.price);

    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.hidden = false;
      } else {
        comparePriceEl.hidden = true;
      }
    }
    if (savePillEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        savePillEl.textContent = 'Save ' + pct + '%';
        savePillEl.hidden = false;
      } else {
        savePillEl.hidden = true;
      }
    }

    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      if (atcTextEl && !variant.available) {
        atcTextEl.textContent = atcBtn.dataset.soldoutText || 'Sold out';
      }
    }
    if (stockRow && stockText) {
      stockRow.classList.toggle('is-out', !variant.available);
      stockText.textContent = variant.available
        ? 'In stock — ships in 1-2 business days'
        : 'Currently sold out';
    }

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* noop */ }
  }

  optionInputs.forEach((input) => {
    input.addEventListener('change', () => {
      const parent = input.closest('.pp-bb-variant-options');
      if (parent) {
        parent.querySelectorAll('.pp-bb-variant-option').forEach((label) => {
          const radio = label.querySelector('input[type="radio"]');
          label.classList.toggle('is-active', radio === input);
        });
      }
      updateVariantUI();
    });
  });

  /* ---------- ATC: AJAX add → open Kaching cart drawer ---------- */
  const form = root.querySelector('#pelvipulse-product-form');
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(form);

      atcBtn && atcBtn.setAttribute('aria-busy', 'true');

      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: fd,
        });

        if (!addRes.ok) {
          const err = await addRes.json().catch(() => ({}));
          throw new Error(err.description || 'Cart add failed');
        }

        // Tell Kaching to refresh and open its drawer
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:update'));

        const kachingDrawer = document.querySelector('kaching-cart-drawer');
        if (kachingDrawer) {
          kachingDrawer.setAttribute('open', 'true');
        }

      } catch (err) {
        console.error('[PelviPulse] ATC error:', err);
        alert('Could not add to cart. Please try again.');
      } finally {
        atcBtn && atcBtn.removeAttribute('aria-busy');
      }
    });
  }

  /* ---------- buy-box accordions ---------- */
  $$('[data-pp-acc]').forEach((acc) => {
    const head = acc.querySelector('[data-pp-acc-head]');
    if (!head) return;
    head.addEventListener('click', () => {
      const open = acc.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- FAQ accordions ---------- */
  $$('[data-pp-faq]').forEach((row) => {
    const btn = row.querySelector('[data-pp-faq-q]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const open = row.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Sticky ATC ---------- */
  const sticky = document.querySelector('[data-pp-sticky]');
  if (sticky) {
    const after = parseInt(sticky.dataset.showAfter, 10) || 700;
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(() => {
        raf = 0;
        const show = window.scrollY > after;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const stickyCta = sticky.querySelector('[data-pp-sticky-cta]');
    if (stickyCta) {
      stickyCta.addEventListener('click', () => {
        if (!form) return;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }
  }

  /* ---------- Final-CTA scroll-to-buybox ---------- */
  $$('[data-pp-scroll-to-buybox]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = root.querySelector('.pp-buybox');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- Comparison swipe hint ---------- */
  $$('[data-pp-cmp-scroll]').forEach((scroller) => {
    const hint = scroller.parentElement && scroller.parentElement.querySelector('.pp-cmp-hint');
    if (!hint) return;
    const hide = () => hint.style.display = 'none';
    scroller.addEventListener('scroll', hide, { once: true, passive: true });
    scroller.addEventListener('touchstart', hide, { once: true, passive: true });
  });

  /* ---------- Kaching Bundles → keep top price + ATC button in sync ---------- */
  function syncPriceFromForm() {
    if (!form || !productJson) return;
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;
    const variant = productJson.variants.find(v => String(v.id) === String(idInput.value));
    if (!variant) return;

    const formatted = formatMoney(variant.price);
    if (priceEl) priceEl.textContent = formatted;
    if (atcPriceEl) atcPriceEl.textContent = formatted;
    if (atcTextEl) atcTextEl.textContent = 'Add to Cart — ' + formatted;

    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.hidden = false;
      } else {
        comparePriceEl.hidden = true;
      }
    }
    if (savePillEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        savePillEl.textContent = 'Save ' + pct + '%';
        savePillEl.hidden = false;
      } else {
        savePillEl.hidden = true;
      }
    }
  }

  if (form) {
    const kachingIdInput = form.querySelector('input[name="id"]');
    if (kachingIdInput) {
      new MutationObserver(syncPriceFromForm).observe(kachingIdInput, { attributes: true, attributeFilter: ['value'] });
    }
    form.addEventListener('input', syncPriceFromForm);
  }
})();